import { CheckboxGroup } from "@rawa/ui/CheckboxGroup"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the chosen options' values, in the order they were ticked, as a
// multi-selection drop-down reports them, or none once every one is unticked.
export const checkboxGroup: ControlRenderer<"checkboxGroup"> = {
  Render: ({ field, value, onChange, error }) => (
    <CheckboxGroup
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value ?? []}
      onChange={(ticked) => onChange(ticked.length === 0 ? undefined : ticked)}
      options={field.options}
      required={field.required}
      error={error}
    />
  ),
}
